import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { useGetTranslationsQuery } from "../../../features/translations/translationsApiSlices";
import Loader from "../../components/Loader";
import PaginateItems from "./components/PaginateItems";
import {
  SelectLocaleID,
  SelectSurveyID,
  initTranslationForm,
} from "../../../features/translations/translationsSlice";
import SettingsCard from "./components/SettingsCard";
import RenderItems from "./components/RenderItems";
const Editor = () => {
  const localeID = useSelector(SelectLocaleID);
  const surveyID = useSelector(SelectSurveyID);
  const dispatch = useDispatch();
  const {
    data,
    isLoading: translationsLoading,
    isSuccess: translationsSuccess,
    isError: isTransalationsError,
    error: translationsError,
  } = useGetTranslationsQuery({ surveyID, localeID });

  useEffect(() => {
    if (translationsSuccess && data) {
      dispatch(initTranslationForm(data));
    }
  }, [translationsSuccess, data, dispatch]);

  if (translationsLoading) {
    return <Loader />;
  } else if (isTransalationsError) {
    return (
      <>
        <p>{JSON.stringify(translationsError)}</p>
      </>
    );
  }

  return (
    <>
      <div className="row">
        <PaginateItems itemsPerPage={8} />
        <SettingsCard />
      </div>
      <RenderItems />
    </>
  );
};

export default Editor;
